var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPloom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 76,
    viewBox: "0 0 197 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_361_20868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9023 23.686H63.9257V27.4818C65.6407 25.0188 67.9818 23.1934 71.6568 23.1934C77.4279 23.1934 82.9268 28.0034 82.9268 36.8411V36.928C82.9268 45.7367 77.5096 50.5757 71.6568 50.5757C67.9001 50.5757 65.5862 48.7502 63.9257 46.635V62.7167H56.9023V23.686ZM75.9307 36.928V36.8411C75.9307 32.4657 73.154 29.5681 69.8601 29.5681C66.5662 29.5681 63.844 32.4657 63.844 36.8411V36.928C63.844 41.3034 66.5662 44.201 69.8601 44.201C73.154 44.201 75.9307 41.3324 75.9307 36.928Z",
    fill: "url(#paint0_linear_361_20868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6018 14.124H93.6251V50.0543H86.6018V14.124Z",
    fill: "url(#paint1_linear_361_20868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1912 37.0149V36.928C97.1912 29.3363 102.935 23.1934 110.639 23.1934C118.316 23.1934 124.005 29.2494 124.005 36.8411V36.928C124.005 44.5197 118.261 50.6626 110.557 50.6626C102.881 50.6626 97.1912 44.6067 97.1912 37.0149ZM117.063 37.0149V36.928C117.063 33.0452 114.423 29.655 110.53 29.655C106.501 29.655 104.106 32.9583 104.106 36.8411V36.928C104.106 40.8108 106.746 44.201 110.639 44.201C114.668 44.201 117.063 40.8977 117.063 37.0149Z",
    fill: "url(#paint2_linear_361_20868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.047 37.0149V36.928C126.047 29.3363 131.791 23.1934 139.495 23.1934C147.171 23.1934 152.861 29.2494 152.861 36.8411V36.928C152.861 44.5197 147.117 50.6626 139.413 50.6626C131.736 50.6626 126.047 44.6067 126.047 37.0149ZM145.919 37.0149V36.928C145.919 33.0452 143.278 29.655 139.386 29.655C135.357 29.655 132.961 32.9583 132.961 36.8411V36.928C132.961 40.8108 135.602 44.201 139.495 44.201C143.523 44.201 145.919 40.8977 145.919 37.0149Z",
    fill: "url(#paint3_linear_361_20868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.102 23.686H163.125V27.4239C164.731 25.2217 166.882 23.1934 170.42 23.1934C173.66 23.1934 176.11 24.7291 177.389 27.3659C179.567 24.6711 182.153 23.1934 185.529 23.1934C190.755 23.1934 193.886 26.5256 193.886 32.9003V50.0831H186.863V35.3633C186.863 31.8282 185.393 30.0027 182.752 30.0027C180.112 30.0027 178.505 31.8282 178.505 35.3633V50.0831H171.482V35.3633C171.482 31.8282 170.012 30.0027 167.372 30.0027C164.731 30.0027 163.125 31.8282 163.125 35.3633V50.0831H156.102V23.686Z",
    fill: "url(#paint4_linear_361_20868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.266 73.3797L127.572 71.2645C128.988 72.3656 130.485 72.9451 131.792 72.9451C133.071 72.9451 133.779 72.3656 133.779 71.4673V71.4094C133.779 70.3372 132.418 69.9895 130.893 69.4969C128.988 68.9174 126.865 68.1061 126.865 65.4693V65.4113C126.865 62.8035 128.879 61.2388 131.438 61.2388C133.044 61.2388 134.813 61.8473 136.175 62.8035L135.004 65.0346C133.752 64.2233 132.445 63.7307 131.383 63.7307C130.24 63.7307 129.587 64.3102 129.587 65.0926V65.1505C129.587 66.1647 130.975 66.5704 132.5 67.0919C134.378 67.7004 136.501 68.6277 136.501 71.0906V71.1486C136.501 74.0172 134.405 75.466 131.737 75.466C129.913 75.408 127.872 74.7126 126.266 73.3797Z",
    fill: "url(#paint5_linear_361_20868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.816 68.3962V68.3382C138.816 64.4265 141.729 61.1812 145.676 61.1812C149.624 61.1812 152.536 64.3685 152.536 68.2803V68.3382C152.536 72.221 149.624 75.4663 145.649 75.4663C141.729 75.4663 138.816 72.279 138.816 68.3962ZM149.596 68.3962V68.3382C149.596 65.9332 147.963 63.9339 145.649 63.9339C143.281 63.9339 141.784 65.9042 141.784 68.2803V68.3382C141.784 70.7143 143.417 72.7136 145.704 72.7136C148.099 72.7136 149.596 70.7432 149.596 68.3962Z",
    fill: "url(#paint6_linear_361_20868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.824 68.3962V68.3382C154.824 64.4554 157.655 61.1812 161.521 61.1812C163.944 61.1812 165.441 62.1374 166.666 63.5282L164.815 65.6435C163.916 64.6293 162.964 63.9339 161.494 63.9339C159.343 63.9339 157.764 65.9042 157.764 68.2803V68.3382C157.764 70.7722 159.343 72.7136 161.603 72.7136C162.991 72.7136 164.025 72.0472 164.951 71.033L166.72 72.8875C165.441 74.3942 163.971 75.4663 161.466 75.4663C157.655 75.4663 154.824 72.279 154.824 68.3962Z",
    fill: "url(#paint7_linear_361_20868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.496 56.3711H172.654V59.3556H169.496V56.3711ZM169.632 61.4709H172.572V75.1765H169.632V61.4709Z",
    fill: "url(#paint8_linear_361_20868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.566 71.2067V71.1487C175.566 68.1932 177.744 66.7444 180.875 66.7444C182.318 66.7444 183.325 66.9762 184.332 67.3239V66.9762C184.332 65.0348 183.216 63.9916 181.147 63.9916C179.704 63.9916 178.643 64.3394 177.472 64.8609L176.683 62.398C178.098 61.7315 179.486 61.2969 181.528 61.2969C183.461 61.2969 184.904 61.8474 185.802 62.8326C186.755 63.8178 187.19 65.2666 187.19 67.0631V75.1764H184.305V73.4668C183.434 74.5679 182.1 75.4662 180.113 75.4662C177.717 75.4372 175.566 73.9594 175.566 71.2067ZM184.386 70.2215V69.2943C183.624 68.9755 182.644 68.7437 181.474 68.7437C179.568 68.7437 178.452 69.613 178.452 71.0328V71.0908C178.452 72.4237 179.541 73.177 180.956 73.177C182.916 73.177 184.386 71.9601 184.386 70.2215Z",
    fill: "url(#paint9_linear_361_20868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.891 56.2261H193.831V75.1764H190.891V56.2261Z",
    fill: "url(#paint10_linear_361_20868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8366 41.9123C22.5227 41.9123 20.6172 39.9129 20.6172 37.421C20.6172 34.958 22.4955 32.9297 24.8366 32.9297C27.1777 32.9297 29.0561 34.929 29.0561 37.421C29.0561 39.9129 27.1505 41.9123 24.8366 41.9123ZM24.8366 35.1608C23.6661 35.1608 22.6861 36.175 22.6861 37.45C22.6861 38.6959 23.6389 39.7391 24.8366 39.7391C26.0344 39.7391 26.9872 38.7249 26.9872 37.45C26.9872 36.175 26.0072 35.1608 24.8366 35.1608Z",
    fill: "url(#paint11_linear_361_20868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5492 60.6309V54.2561C14.7909 53.0681 8.82922 45.998 8.82922 37.4211C8.82922 28.8442 14.7909 21.745 22.5492 20.586V14.2402C11.3609 15.4572 2.94922 25.6278 2.94922 37.3631C2.94922 41.4198 2.94922 75.9882 2.94922 75.9882C15.8253 75.9882 15.5259 64.2529 15.5259 59.5588C17.8126 60.2542 19.7181 60.5439 22.5492 60.6309Z",
    fill: "url(#paint12_linear_361_20868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0273 14.1533C25.0273 14.1533 37.8218 14.4721 39.1285 29.8004C38.0396 27.1056 33.3573 20.4701 25.0273 20.4121C25.0273 19.9485 25.0273 14.1533 25.0273 14.1533Z",
    fill: "url(#paint13_linear_361_20868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0272 60.7754C25.0272 60.7754 29.7911 60.8334 34.4733 58.3414C41.1972 54.7484 49.0644 45.1863 45.9883 31.3647C45.2806 44.375 34.31 54.4586 25 54.4586C25.0272 54.8933 25.0272 60.7754 25.0272 60.7754Z",
    fill: "url(#paint14_linear_361_20868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4609 17.6592C36.4609 17.6592 41.497 22.8169 40.2176 32.6977C41.0343 35.7982 41.3337 40.3184 39.1015 45.1285C42.2865 40.898 49.1737 26.5548 36.4609 17.6592Z",
    fill: "url(#paint15_linear_361_20868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9251 -1.17529H50.8906V76.5095H51.9251V-1.17529Z",
    fill: "url(#paint16_linear_361_20868)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_361_20868",
    x1: 69.9146,
    y1: 23.1934,
    x2: 69.9146,
    y2: 62.7167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5235E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B02D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_361_20868",
    x1: 90.1135,
    y1: 14.124,
    x2: 90.1135,
    y2: 50.0543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5235E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B02D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_361_20868",
    x1: 110.598,
    y1: 23.1934,
    x2: 110.598,
    y2: 50.6626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5235E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B02D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_361_20868",
    x1: 139.454,
    y1: 23.1934,
    x2: 139.454,
    y2: 50.6626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5235E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B02D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_361_20868",
    x1: 174.994,
    y1: 23.1934,
    x2: 174.994,
    y2: 50.0831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5235E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B02D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_361_20868",
    x1: 131.383,
    y1: 61.2388,
    x2: 131.383,
    y2: 75.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5235E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B02D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_361_20868",
    x1: 145.676,
    y1: 61.1812,
    x2: 145.676,
    y2: 75.4663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5235E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B02D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_361_20868",
    x1: 160.772,
    y1: 61.1812,
    x2: 160.772,
    y2: 75.4663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5235E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B02D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_361_20868",
    x1: 171.075,
    y1: 56.3711,
    x2: 171.075,
    y2: 75.1765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5235E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B02D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_361_20868",
    x1: 181.378,
    y1: 61.2969,
    x2: 181.378,
    y2: 75.4662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5235E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B02D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_361_20868",
    x1: 192.361,
    y1: 56.2261,
    x2: 192.361,
    y2: 75.1764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5235E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B02D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_361_20868",
    x1: 24.8366,
    y1: 32.9297,
    x2: 24.8366,
    y2: 41.9123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5235E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B02D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_361_20868",
    x1: 12.7492,
    y1: 14.2402,
    x2: 12.7492,
    y2: 75.9882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5235E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B02D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_361_20868",
    x1: 32.0779,
    y1: 14.1533,
    x2: 32.0779,
    y2: 29.8004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5235E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B02D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_361_20868",
    x1: 35.8375,
    y1: 31.3647,
    x2: 35.8375,
    y2: 60.7755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5235E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B02D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_361_20868",
    x1: 40.152,
    y1: 17.6592,
    x2: 40.152,
    y2: 45.1285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5235E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B02D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_361_20868",
    x1: 51.4078,
    y1: -1.17529,
    x2: 51.4078,
    y2: 76.5095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5235E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B02D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6231"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_361_20868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 76,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPloom);
export default __webpack_public_path__ + "static/media/ploom.d93db48eddf87da4c0bc75da79600534.svg";
export { ForwardRef as ReactComponent };